import React from "react"
import glamorous from "glamorous"
import style from "utils/style"

const OtherSites = props => (
  <Wrapper>
    <Logos>
      <a href="http://campstaff.com">
        <CampStaffImage src="campstaff-logo-min.png" />
      </a>
      <a href="http://nurses.campstaff.com">
        <CampStaffNursesImage src="csn-logo-min.png" />
      </a>
    </Logos>
    <Text>
      Looking for a summer camp job? <em>Try one of our other sites.</em>
    </Text>
  </Wrapper>
)

const CampStaffImage = glamorous.img({
  paddingRight: 30,
  "@media (max-width: 450px)": {
    paddingBottom: 10,
  },
})

const CampStaffNursesImage = glamorous.img({
  paddingLeft: 30,
  "@media (max-width: 450px)": {
    paddingTop: 10,
  },
})

const Logos = glamorous.div({
  display: "flex",
  margin: "auto",
  "@media (max-width: 450px)": {
    flexDirection: "column",
  },
})

const Text = glamorous.p({
  display: "inline-block",
  margin: "auto",
  color: style.colors.silver,
  padding: 30,
  textAlign: "center",
  "@media (max-width: 450px)": {
    paddingLeft: 0,
    paddingRight: 0,
    width: "90%",
  },
})

const Wrapper = glamorous.div({
  display: "flex",
  flexDirection: "column",
  padding: 30,
})

export default OtherSites



// WEBPACK FOOTER //
// ./src/scenes/Home/OtherSites.js